import { Pill } from '#components/atoms/pill/Pill.tsx';
import type { DirectoryUserState } from '#dn-types/google-idp.ts';

const labels: Record<DirectoryUserState, string> = {
  active: 'Active',
  suspended: 'Suspended',
  archived: 'Archived',
  deleted: 'Deleted',
  // Signed in with Google, but outside the connected Workspace's domains, so sync never acts on them.
  unmanaged: 'Not in directory',
};

/** {@link DirectoryStatePill} shows what the connected Google Workspace directory says about a user. */
export function DirectoryStatePill({ state }: { state: DirectoryUserState }) {
  const variant =
    state === 'active' ? 'success'
    : state === 'unmanaged' ? 'default'
    : 'alert';

  return <Pill variant={variant}>{labels[state]}</Pill>;
}
